import { Injectable, inject } from "@angular/core";
import { ReportingDashboardComponent } from "../components/dashboard.component";
import { HttpHeaders } from "@angular/common/http";

@Injectable()
/**
 * A service that upon activation will try to get a reference to the Reporting Dashboard Component,
 * so consumers can send additional information to the server for improved permission checks.
 *
 * Note this service and those injecting it should be provided at the same level, which most likely
 * is at component level. This is because it needs to be activated at the same time that the component
 * in order to know if the component is being rendered as a Dashboard descendant.
 */
export class DashboardContextService {
    readonly DashboardIdHeaderName = "X-Rb3-Reporting-Dashboard-Id";

    private dashboardComponent = inject(ReportingDashboardComponent, { optional: true });

    get dashboardHeader() {
        const dashboardId = this.dashboardComponent?.dashboardId;

        if (!dashboardId) return null;

        return new HttpHeaders({ [this.DashboardIdHeaderName]: dashboardId });
    }
}
